// extracted by mini-css-extract-plugin
export var errorMsg = "styles-__errormsg-module___errorMsg";